<template>
 <div id="instance-edit">
  <vs-popup ref="popup-cropper" class="profile-image-popup" title="Alterar Foto" :active.sync="profilePresets.picture.crop" v-on:close="profilePresets.picture.crop = false">
    <image-cropper
       :src="profilePresets.picture.imageUrl"
       stencil="circle-stencil"
       styleRestriction="fit-area"
       @on-cropp-image="imageCropped"
    ></image-cropper>
  </vs-popup>

  <vs-popup title="Alterar Foto" :active.sync="profilePresets.picture.edit" @close="closePopup()">
    <upload
      automatic
      fileName="file"
      class="profile-image-popup"
      ref="uploadComponent"
      text="Adicionar Imagem"
      accept=".jpg, .jpeg, .png"
      :maxSize="3"
      :limit="1"
      :single-upload="true"
      :action="uploadApiUrl"
      :headers="{ Authorization: 'Bearer ' + bearer }"
      @on-error="errorUpload"
      @on-delete="deleteUpload"
      @on-success="successUpload"
      @on-upload-start="progressUpload"
    />

   <div class="flex flex-wrap items-center justify-center">
     <vs-button class="mr-4 sm:mb-0 mb-2" type="filled" :disabled="profilePresets.picture.lockButton" @click="updatePicture">
       Salvar
     </vs-button>
   </div>
  </vs-popup>

  <section class="pb-8">
    <vs-row>
      <vs-col vs-lg="9" vs-sm="9" vs-xs="12">
       <section class="edit-profile">
          <div class="container mx-auto pl-10 py-3">
            <h5>Perfil comercial do WhatsApp</h5>

            <vs-row class="flex align-items-center">
              <vs-col vs-type="flex" vs-align="center" vs-w="3">
                <b class="p-6">Foto do perfil</b>
              </vs-col>

              <vs-col vs-type="flex"  vs-align="center" vs-w="7">
                <vs-avatar v-if="profile.profile_picture_url" :src="profile.profile_picture_url"></vs-avatar>
                <vs-avatar v-else></vs-avatar>

                <vs-button icon-pack="feather" icon="icon-edit" type="border" svgClasses="w-5 h-5" class="ml-5" @click="setEdit('picture')">
                  <span>Alterar</span>
                </vs-button>
              </vs-col>
            </vs-row>

            <vs-row class="flex align-items-center">
              <vs-col vs-type="flex" vs-align="center" vs-w="3">
                <b class="p-6">Sobre</b>
              </vs-col>

              <vs-col vs-type="flex"  vs-align="center" vs-w="7">
                <div v-if="!profilePresets.about.edit" :class="{'text-danger': !profile.about}">
                  <p>{{ profile.about || 'Nenhum sobre adicionado' }}</p>
                </div>
                <div v-else class="w-full">
                  <vs-input
                    type="text"
                    class="w-full"
                    key="about"
                    name="about"
                    @input="setState()"
                    v-validate="'required'"
                    v-model="profile.about"
                    :maxlength="profilePresets.about.limit"
                  ></vs-input>

                  <span class="text-sm">
                    Caracteres: {{profile.about.length}}/{{ profilePresets.about.limit }}
                  </span>

                  <span class="ml-4 text-danger text-sm" v-if="!profile.about">
                    O campo deve ser preenchido.
                  </span>
                </div>
              </vs-col>

              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5" class="text-right hover:text-primary" @click.prevent="setEdit('about')"/>
              </vs-col>
            </vs-row>
          </div>

          <div class="container mx-auto pl-10 py-3">
            <h5>Perfil de negócios</h5>

            <vs-row class="flex align-items-center">
              <vs-col vs-type="flex" vs-align="center" vs-w="3">
                <b class="p-6">Descrição</b>
              </vs-col>

              <vs-col vs-type="flex"  vs-align="center" vs-w="7">
                <div v-if="!profilePresets.description.edit" >
                  <p>{{ profile.description || 'Nenhuma descrição adicionado' }}</p>
                </div>
                <div v-else class="w-full">
                  <vs-input
                    type="text"
                    class="w-full"
                    @input="setState()"
                    v-model="profile.description"
                    :maxlength="profilePresets.description.limit"
                  ></vs-input>

                  <span class="text-sm">
                    Caracteres: {{profile.description.length}}/{{ profilePresets.description.limit }}
                  </span>
                </div>
              </vs-col>

              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5" class="text-right hover:text-primary" @click.prevent="setEdit('description')"/>
              </vs-col>
            </vs-row>

            <vs-row class="flex align-items-center">
              <vs-col vs-type="flex" vs-align="center" vs-w="3">
                <b class="p-6">Endereço</b>
              </vs-col>

              <vs-col vs-type="flex" vs-align="center" vs-w="7">
                <div v-if="!profilePresets.address.edit" >
                  <p>{{ profile.address || 'Nenhum endereço adicionado' }}</p>
                </div>
                <div v-else class="w-full">
                  <vs-input
                    type="text"
                    class="w-full"
                    @input="setState()"
                    v-model="profile.address"
                    :maxlength="profilePresets.address.limit"
                  ></vs-input>

                  <span class="text-sm">
                    Caracteres: {{profile.address.length}}/{{ profilePresets.address.limit }}
                  </span>
                </div>
              </vs-col>

              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5" class="text-right hover:text-primary" @click.prevent="setEdit('address')"/>
              </vs-col>
            </vs-row>

            <vs-row class="flex align-items-center">
              <vs-col vs-type="flex" vs-align="center" vs-w="3">
                <b class="p-6">Email</b>
              </vs-col>

              <vs-col vs-type="flex" vs-align="center" vs-w="7">
                <div v-if="!profilePresets.email.edit" >
                  <p>{{ profile.email || 'Nenhum email adicionado' }}</p>
                </div>
                <div v-else class="w-full">
                  <vs-input
                    type="text"
                    class="w-full"
                    key="email"
                    name="email"
                    @input="setState()"
                    v-validate="'email'"
                    v-model="profile.email"
                    :maxlength="profilePresets.email.limit"
                  ></vs-input>

                  <span class="text-sm">
                    Caracteres: {{profile.email.length}}/{{ profilePresets.email.limit }}
                  </span>

                  <span class="ml-4 text-danger text-sm" v-show="errors.has('email')">
                    O campo deve ser um email válido.
                  </span>
                </div>
              </vs-col>

              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5" class="text-right hover:text-primary" @click.prevent="setEdit('email')"/>
              </vs-col>
            </vs-row>

            <vs-row class="flex align-items-center" v-for="(website, key) in profilePresets.websites.items" :href="website" :key="key">
              <vs-col vs-type="flex" vs-align="center" vs-w="3">
                <b class="p-6">Site ({{website}})</b>
              </vs-col>

              <vs-col vs-type="flex" vs-align="center" vs-w="7">
                <div v-if="!profilePresets.websites.edit" >
                  <p>{{ profile.websites[key] || 'Nenhum site adicionado' }}</p>
                </div>
                <div v-else class="w-full">
                  <vs-input
                    type="text"
                    class="w-full"
                    :key="'site' + key"
                    :name="'site' + key"
                    @input="setState()"
                    v-validate="'url'"
                    v-model="profile.websites[key]"
                    :maxlength="profilePresets.websites.limit"
                  ></vs-input>

                  <span class="text-sm">
                    Caracteres: {{profile.websites[key] ? profile.websites[key].length : 0}}/{{ profilePresets.websites.limit }}
                  </span>

                  <span class="ml-4 text-danger text-sm" v-show="errors.has('site' + key)">
                    O campo deve ser um site válido.
                  </span>
                </div>
              </vs-col>

              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5" class="text-right hover:text-primary" @click.prevent="setEdit('websites')"/>
              </vs-col>
            </vs-row>
          </div>

           <div class="float-right mr-5 mt-5">
             <vs-button @click="updateProfile" :disabled="!profile.about">
                <span>Salvar</span>
             </vs-button>
           </div>
        </section>
      </vs-col>

      <vs-col vs-lg="3" vs-sm="3" vs-xs="0" style="position: sticky; top: 0;">
        <section class="preview-profile">
          <div>
            <h5>Visualização do Perfil</h5>
          </div>

          <div class="container mx-auto px-4 py-8">
            <div class="text-center">
              <img class="w-32 h-32 rounded-full mx-auto mb-4" v-if="profile.profile_picture_url" :src="profile.profile_picture_url" alt="profile picture">
              <img class="w-32 h-32 rounded-full mx-auto mb-4" v-else :src="profilePresets.defaultValues.profile_picture_url" alt="profile picture default">
            </div>

            <div class="my-4">
              <h3 class="text-lg font-semibold">Informações da empresa</h3>
            </div>

            <div class="my-4">
              <div class="flex">
                <feather-icon icon="FileTextIcon" svgClasses="w-5 h-5" class="p-5"/>
                <p class="align-self-center">{{ profile.description || 'Nenhuma descrição adicionada'}}</p>
              </div>

              <div class="flex" v-if="profile.address">
                <feather-icon icon="MapPinIcon" svgClasses="w-5 h-5" class="p-5"/>
                <p class="align-self-center">{{ profile.address || 'Nenhum endereço adicionado' }}</p>
              </div>

              <div class="flex" v-if="profile.email">
                <feather-icon icon="MailIcon" svgClasses="w-5 h-5" class="p-5"/>
                <p class="align-self-center">{{ profile.email || 'Nenhum email adicionado'}}</p>
              </div>

              <div class="flex" v-if="profile.websites.length">
                <feather-icon icon="ExternalLinkIcon" svgClasses="w-5 h-5" class="p-5"/>
                <ol class="d-inline-block align-self-center">
                  <li v-for="(website, key) in profile.websites" :key="key">
                    <p v-if="!website"> Nenhum site adicionado </p>
                    <a v-else target="_blank" :href="website">{{ website }}</a>
                  </li>
                </ol>
              </div>
            </div>

            <div class="my-4">
              <h3 class="text-lg font-semibold">Sobre e número de telefone</h3>
            </div>

            <div class="my-4">
              <div class="flex">
                <feather-icon icon="BriefcaseIcon" svgClasses="w-5 h-5" class="p-5"/>
                <p class="align-self-center">{{ profile.about || 'Nenhum sobre adicionado' }}</p>
              </div>

              <div class="flex">
                <feather-icon icon="PhoneIcon" svgClasses="w-5 h-5" class="p-5"/>
                <p class="align-self-center">{{ instanceObj.phone_number }}</p>
              </div>
            </div>
          </div>
        </section>
      </vs-col>
    </vs-row>
  </section>
 </div>
</template>

<script>

import {formatRouteTenantPath, instanceObject} from "@/utils";
import Upload from "@/components/upload/Upload.vue";
import ImageCropper from "@/components/image-cropper/ImageCropper.vue";
import moduleWhatsappProfile from "@/store/whatsappProfile/moduleWhatsappProfile";

export default {
 name: 'instance-edit',
 components: {ImageCropper, Upload},
 data() {
  return {
    profilePresets:{
      picture:{
        crop: false,
        edit: false,
        imageUrl: null,
        lockButton: true
      },
      about:{
        edit: false,
        limit: 139
      },
      address:{
        edit: false,
        limit: 256
      },
      description:{
        edit: false,
        limit: 512
      },
      email:{
        edit: false,
        limit: 128
      },
      websites:{
        edit: false,
        limit: 256,
        items: ['Primário', 'Secundário']
      },
      defaultValues:{
        about: '',
        email: '',
        address: '',
        websites: [''],
        vertical: '',
        description: '',
        messaging_product: 'whatsapp',
        profile_picture_url: 'https://cdn.onlinewebfonts.com/svg/img_131793.png'
      }
    }
  }
 },
 provide() {
   return {
      $validator: this.$validator
   }
 },
 watch:{
   profile(){
     this.$validator.validateAll().then();
   },
 },
 computed:{
  uploadApiUrl() {
   return localStorage.getItem('baseUrl') + '/api/file/upload'
  },
  bearer() {
   return this.$store.state.auth.bearer
  },
  instanceId(){
    return Number(this.$route.params.id);
  },
  instanceObj(){
    return instanceObject(this.instanceId)
  },
  activeUserPermission(){
    return this.$store.state.AppActiveUser.role;
  },
  profile(){
    return JSON.parse(JSON.stringify(this.$store.state.whatsappProfile.whatsappProfile))
  }
 },
 methods: {
  async isValid(){
    return this.$validator.validateAll().then((valid) => { return valid }).catch((error) => { console.error(error) })
  },
  setEdit(type){
    this.profilePresets[type].edit = !this.profilePresets[type].edit
  },
  setState() {
   this.$store.commit('whatsappProfile/UPDATE_PROFILE', this.profile);
  },
  async fetchProfile(){
   await this.$store.dispatch("whatsappProfile/fetch", {id: this.instanceId})
     .then()
     .catch((error) => { console.error(error) })
  },
  async updateProfile(){
   if (await this.isValid()){
     this.$store.dispatch("whatsappProfile/update", {id: this.instanceId, profile: this.profile})
       .then(() => {
         this.$vs.notify({
           color: 'success',
           title: 'Perfil atualizado!',
           time: 7000
         });
       }).catch((error) => { console.error(error) })
   }
  },
  async updatePicture(){
   this.$store.dispatch("whatsappProfile/updatePicture", {id: this.instanceId, picture: this.profilePresets.picture.imageUrl})
     .then(() => {
       this.closePopup();
       this.$vs.notify({
         color: 'success',
         title: 'Imagem de perfil atualizada!',
         time: 7000
       });
     }).catch((error) => { console.error(error) })
  },
  async instanceFind(){
    if ( !this.instanceObj && Number.isInteger(this.instanceId)) {
      await this.$store.dispatch("instance/fetch", {id: this.instanceId})
    }

    if ( !this.instanceObj || !this.instanceObj['integration_id']) {
      this.$router.push(formatRouteTenantPath('/instances/list/choose-instance'));

      this.$vs.notify({
        color: 'danger',
        title: 'Acesso não permitido!',
        time: 7000
      });
    }

    await this.fetchProfile();
  },
  progressUpload(){
    this.profilePresets.picture.imageUrl = null
    this.profilePresets.picture.lockButton = true
  },
  successUpload(response) {
    this.profilePresets.picture.crop = true
    this.profilePresets.picture.imageUrl = response.data.fileUrl
  },
  imageCropped(response) {
    this.profilePresets.picture.crop = false
    this.profilePresets.picture.lockButton = false
    this.profilePresets.picture.imageUrl = response.data.fileUrl
  },
  deleteUpload(event){
    this.profilePresets.picture.imageUrl = null;
    this.profilePresets.picture.lockButton = true;

    if (event.method && event.method !== 'all'){
      this.$refs.uploadComponent.removeFile(null, true)
    }
  },
  errorUpload(request) {
    this.$vs.notify({
      color: 'danger',
      title: 'Erro ao carregar a imagem',
      text: (request.data.message || '')
    })
  },
  closePopup(){
    this.profilePresets.picture.crop = false
    this.profilePresets.picture.edit = false
    this.profilePresets.picture.imageUrl = null
    this.profilePresets.picture.lockButton = true;
    this.$refs.uploadComponent.removeFile(null, true)
  }
 },
 created() {
    if ( !moduleWhatsappProfile.isRegistered ) {
     this.$store.registerModule('whatsappProfile', moduleWhatsappProfile)
     moduleWhatsappProfile.isRegistered = true
    }

   this.instanceFind();
 },
 destroyed() {
   this.$store.commit('whatsappProfile/UPDATE_PROFILE', this.profilePresets.defaultValues);
 }
}
</script>

<style lang="scss">

.profile-image-popup {
  .con-img-upload {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
}

#instance-edit{
  white-space: normal !important;
  word-break: break-word !important;

  .align-self-center {
    align-self: center !important;
  }

  .align-items-center {
    align-items: center !important;
  }

  .container-width {
    width: 70%;
  }

  .preview-profile{
    padding: 10px;
    background: #fff;
    border-radius:10px;
    border: 3px dotted rgba(0, 0, 0, 0.2);
    box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
  }
}

</style>